import React from 'react'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'

const EmptyDataInPeriodExtract = () => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      margin="32px 0px 0px"
      flex="1"
    >
      <Text size="xxs" color="gray" font="custom">
        Não existem dados para o período selecionado
      </Text>
    </Flex>
  )
}

export default React.memo(EmptyDataInPeriodExtract)
